import { render } from "./GoalPage.vue?vue&type=template&id=70702ff8&ts=true"
import script from "./GoalPage.vue?vue&type=script&lang=ts"
export * from "./GoalPage.vue?vue&type=script&lang=ts"

import "./GoalPage.vue?vue&type=style&index=0&id=70702ff8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__